// Copyright (C) 2021 Bystronic Laser AG

import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { GanttIntervalData, CutOrTubesDeviceGanttStatus } from '../chartsData';
import { ProcedureName } from '../abstract/chartGenerator';
import { getStateColour } from '@/utils/color';
import i18n from '@/i18n';
import { AbstractGanttChartTableGenerator } from '@/models/Charts/gantt/abstractGanttChartTableGenerator';
import { values } from '@/utils/enum';

/**
 * Used both for the cut and tubes intraday availability Gantt chart tables.
 */
export class CutOrTubesIntradayAvailabilityGanttGenerator extends AbstractGanttChartTableGenerator<CutOrTubesDeviceGanttStatus> {
  constructor(procedure: ProcedureName) {
    super(procedure);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: FilterTimeSpanEnum | [string, string],
  ): Promise<GanttIntervalData<CutOrTubesDeviceGanttStatus>[] | null> {
    // Data retrieved by CutOrTubesIntradayAvailabilityTableRetriever
    throw new Error('This method does not need to be called nor implemented');
  }

  protected override getIntervalColor(
    interval: GanttIntervalData<CutOrTubesDeviceGanttStatus>,
    index: number,
  ): string {
    return getStateColour(interval.value);
  }

  protected override getPossibleIntervalValues(
    data: GanttIntervalData<CutOrTubesDeviceGanttStatus>[],
  ): CutOrTubesDeviceGanttStatus[] {
    return values(CutOrTubesDeviceGanttStatus);
  }

  protected override getLocalizedStateName(state: string): string {
    return i18n
      .t(`widget_info_text.gantt_chart_table.states.${state}`)
      .toString();
  }
}
